const state = () => ({
  messages: [],
  suggestions: [],
  placeholder: { text: 'Message', type: 'text' },
});

const getters = {
  messages: function (state) {
    return state.messages;
  },
  suggestions: function (state) {
    return state.suggestions;
  },
  placeholder: function (state) {
    return state.placeholder;
  },
};

const mutations = {
  SET_MESSAGES: function (state, messages) {
    state.messages = messages;
  },
  PUSH_MESSAGE: function (state, message) {
    for (let i = state.messages.length - 1; i >= 0; i--) {
      if (state.messages[i]._id === undefined && !state.messages[i].is_emika) {
        state.messages.splice(i, 1);
        break;
      }
    }
    state.messages.push(message);
  },
  SET_SUGGESTIONS: function (state, suggestions) {
    state.suggestions = suggestions;
  },
  SET_PLACEHOLDER: function (state, placeholder) {
    state.placeholder = placeholder;
  },
};

const actions = {
  FETCH_MESSAGES: async function ({ commit, state }, offset = 0) {
    const response = await this.$api().get('/chat/fetch_messages', {
      params: {
        token: localStorage.getItem('token'),
        offset,
        limit: 25,
      },
    });
    if (response.data.ok) {
      const messages = response.data.payload.messages;
      const newMess = messages.reverse(); // .concat(state.messages);
      commit('SET_MESSAGES', newMess);
      commit('SET_SUGGESTIONS', response.data.payload.suggestions);
      commit('SET_PLACEHOLDER', response.data.payload.placeholder);
      return response.data.payload;
    } else {
      throw new Error(response.data.error || 'Что-то пошло не так');
    }
  },
  SEND_MESSAGE: function ({ commit }, userMessage) {
    commit('SET_SUGGESTIONS', []);
    this.$api().post('/chat/send_message', {}, {
      params: {
        token: localStorage.getItem('token'),
        text: userMessage.text,
        is_password: userMessage.is_password,
      },
    });
  },
  GET_MESSAGE: function ({ dispatch, commit }, message) {
    setTimeout(function () {
      if (message.is_emika && localStorage.getItem('lastSoundedMessage') !== message._id) {
        localStorage.setItem('lastSoundedMessage', message._id);
      }
      commit('PUSH_MESSAGE', message);
    }, message.delay);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
